export default {"src":"/_next/static/media/logo-nav.8402a7f8.svg","height":74,"width":478,"blurWidth":0,"blurHeight":0};